import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Filters } from "../../public/interfaces/Filters";
import { FiltersState } from "../../public/interfaces/FiltersState";
import { FilterOption } from "../../public/interfaces/FilterOption";
import { DateFilter } from "../../public/interfaces/DateFilter";
import { Tag } from "../../public/interfaces/Tag";

const initialFilters: Filters = {
  hasWords: null,
  types: [],
  sites: [],
  tags: [],
  date: null,
  author: null,
  hasTips: null 
};

const initialState: FiltersState = {
  filters: initialFilters
};

export const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setHasWords: (state, action: PayloadAction<string | null>) => {
      state.filters.hasWords = action.payload;
    },
    setTypes: (state, action: PayloadAction<FilterOption[]>) => {
      state.filters.types = action.payload;
    },
    setSites: (state, action: PayloadAction<FilterOption[]>) => {
      state.filters.sites = action.payload;
    },
    setDate: (state, action: PayloadAction<DateFilter | null>) => {
      state.filters.date = action.payload;
    },
    setTags: (state, action: PayloadAction<Tag[]>) => {
      state.filters.tags = action.payload;
    },
    setAuthor: (state, action: PayloadAction<string | null>) => {
      state.filters.author = action.payload;
    },
    setHasTips: (state, action: PayloadAction<boolean | null>) => {
      state.filters.hasTips = action.payload;
    },
    setFilters: (
      state,
      action: PayloadAction<{
        hasWords: string | null;
        types: FilterOption[];
        sites: FilterOption[];
        date: DateFilter | null;
        tags: Tag[];
        author: string | null;
        hasTips: boolean | null;
      }>
    ) => {
      state.filters = action.payload;
    },
    resetFilters: (state) => {
      state.filters = initialFilters;
    }
  }
});

export const { setHasWords, setTypes, setSites, setTags, setAuthor, setDate, setHasTips, setFilters, resetFilters } = filtersSlice.actions;
export default filtersSlice;
